import getArrow from './getArrow';

export default getArrow;
